import { render, staticRenderFns } from "./mailCommercial.vue?vue&type=template&id=204d06be&scoped=true&"
import script from "./mailCommercial.vue?vue&type=script&lang=js&"
export * from "./mailCommercial.vue?vue&type=script&lang=js&"
import style0 from "./mailCommercial.vue?vue&type=style&index=0&id=204d06be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d06be",
  null
  
)

export default component.exports